import { useState } from 'react';
import { Alert, Button, Stack, TextField, Typography } from '@mui/material';
import { planBarrelDispatch } from './api/tumblerApi';
import { bangkokLocalInputToIso, formatBangkokDateTime } from './utils/bangkokTime';
import normalizeApiError from './utils/normalizeApiError';

export default function DispatchPlanForm({ allocation, plant, factory, accessToken, onSaved }) {
  const line = allocation.barrel_line || '';
  const [transport, setTransport] = useState('');
  const [useAt, setUseAt] = useState(allocation.planned_use_at ? formatBangkokDateTime(allocation.planned_use_at).replace(' ', 'T') : '');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const save = async () => {
    if (!line || transport === '' || !Number.isFinite(Number(transport)) || Number(transport) < 0 || !useAt) {
      setError(!line ? 'This barrel has no line. Correct the barrel record first.' : 'Enter consumption start and transport time (0 or more minutes).'); return;
    }
    setBusy(true); setError('');
    try {
      await planBarrelDispatch({ allocationId: allocation.id, plant, factory, accessToken,
        body: { transport_minutes: Number(transport), planned_use_at: bangkokLocalInputToIso(useAt) } });
      await onSaved();
    } catch (err) { setError(normalizeApiError(err, 'Unable to plan barrel movement.').summary); }
    finally { setBusy(false); }
  };
  return <Stack spacing={1} sx={{ border: '1px solid', borderColor: 'divider', p: 2 }}>
    <Typography>Barrel #{allocation.core_tumbler} · {allocation.sku} · Actual {allocation.actual_barrel_weight ?? '—'} kg · PO {allocation.downstream_process_order || '—'}</Typography>
    <Typography variant="caption">Expiry: {formatBangkokDateTime(allocation.expiry_at)} · Full physical barrel, maximum 200 kg.</Typography>
    <Stack direction={{ xs: 'column', md: 'row' }} spacing={1}>
      <TextField label="Barrel line" value={line} InputProps={{ readOnly: true }} helperText="From the barrel record" sx={{ minWidth: 160 }} size="small" />
      <TextField label="Transport (minutes)" type="number" value={transport} onChange={(e) => setTransport(e.target.value)} size="small" />
      <TextField label="Required consumption start (Bangkok)" type="datetime-local" value={useAt} onChange={(e) => setUseAt(e.target.value)} InputLabelProps={{ shrink: true }} size="small" />
      <Button disabled={busy} onClick={save} variant="outlined">{busy ? 'Planning…' : 'Plan dispatch'}</Button>
    </Stack>
    {error && <Alert severity="error">{error}</Alert>}
  </Stack>;
}
